module.exports = __webpack_public_path__ + "img/mdm-deploy-2.5c3fbd43.jpg";